import { PortionMaterialSizeDescriptionField } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';

import { toString as objectPathToString, parse as parseObjectPath } from 'Lib/Object/Path/shared';
import { dropLast as dropLastElementFromObjectPath } from 'ramda';

import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent } from '../../../../Core';

let IntermediatePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
  namePrefix,
}) => {
  //Expected path:
  //  data.WholePortion.Separation.FinePortion.Subspecimen.Separation.CoarsePortion
  //
  // Whole Portion
  //   Separation
  //   |- Coarse Portion                     (coarse portion sieving section)
  //   |- Fine Portion
  //      |- Fine Portion Subspecimen
  //      |- Separation
  //         |- Coarse Portion               <-- intermediate portion sieving section
  //         |- Fine Portion
  //            |- Fine Portion Subspecimen  (fine portion sieving section)
  const parentPortionPath = objectPathToString(dropLastElementFromObjectPath(2, parseObjectPath(namePrefix!)));
  const isWashed = useSelector(
    pipe(createWorksheetSelector!(`${parentPortionPath}.Washing.IsWashed`, false), valueOrDefault(false))
  );

  return (
    <ListFieldSection>
      <PortionMaterialSizeDescriptionField />
      <NamePrefixModifier namePrefix={parentPortionPath}>
        {isWashed ? (
          <Field input={<TextOutput />} name="Washing.WashedDryMass" label="Sieve Portion Washed Material Dry Mass" />
        ) : (
          <Field input={<TextOutput />} name="Masses.DryMass" label="Sieve Portion Material Dry Mass" />
        )}
      </NamePrefixModifier>
      <Field input={<TextOutput />} name="Masses.MassUpscaleFactor" />
    </ListFieldSection>
  );
};
IntermediatePortionSievingMassesSection = withInjectedProps(IntermediatePortionSievingMassesSection);

export { IntermediatePortionSievingMassesSection };
export default IntermediatePortionSievingMassesSection;
